import { useEffect, useState } from "react";
import { BaseModal } from "../BaseModal/BaseModal";

interface TextInputModalProps {
  show: boolean;
  title: string;
  body?: string;
  onYes: (value: any) => void;
  onNo: () => void;
  yesLabel: string;
  noLabel: string;
  placeholder: string;
}

export const TextInputModal = ({
  show,
  title,
  body,
  onYes,
  onNo,
  yesLabel = "",
  noLabel = "",
  placeholder = "",
}: TextInputModalProps) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue("");
  }, [show]);
  return (
    <BaseModal
      show={show}
      title={title}
      body={
        <>
          {body && <p>{body}</p>}
          <input
            type="text"
            value={inputValue}
            placeholder={placeholder}
            onChange={(e) => setInputValue(e.target.value)}
            className="form-control mt-2 mb-2"
          />
        </>
      }
      onYes={() => onYes(inputValue)}
      onNo={onNo}
      yesLabel={yesLabel}
      noLabel={noLabel}
    />
  );
};
